const splits = {
  WIDGETS: getPinned('WIDGETS', 1)
}

const $containers = document.querySelectorAll('.js-split-partial')

for (let i = 0; i < $containers.length; i++) {
  init($containers[i])
}

function init ($container) {
  let a = $container.getAttribute('data-a')
  let b = $container.getAttribute('data-b')
  let splitKey = $container.getAttribute('data-split')
  let which = splits[splitKey]
  let partial = which === 'a' ? a : b
  let callback = $container.getAttribute(`data-${which}-callback`)

  window.fetch(`/_partials/${partial}`, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(res => res.text())
    .then(html => {
      $container.innerHTML = html
      if (callback) {
        callback.split(',').map(x => x.trim()).forEach(cb => {
          window.LBA[cb]($container)
        })
      }
    })
}

function getPinned (key, aWeight = 0.5) {
  return 'b';

  try {
    let saved = window.localStorage.getItem(`split-${key}`)
    if (saved && (saved === 'a' || saved === 'b')) {
      return saved
    }
    let which = Math.random() >= aWeight ? 'a' : 'b'
    window.localStorage.setItem(`split-${key}`, which)
    return which
  } catch (_) {
    return Math.random() <= aWeight ? 'a' : 'b'
  }
}



// WEBPACK FOOTER //
// ./src/js/_split-partial.js